import { render, staticRenderFns } from "./questionBase.vue?vue&type=template&id=29a4062a&scoped=true&"
import script from "./questionBase.vue?vue&type=script&lang=js&"
export * from "./questionBase.vue?vue&type=script&lang=js&"
import style0 from "./questionBase.vue?vue&type=style&index=0&id=29a4062a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4062a",
  null
  
)

export default component.exports